import React, { Suspense } from 'react'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import ScrollToTop from './hooks/ScrollToTop'
import Home from './views/Home';
import * as ROUTES from './constant/routes'

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <Router>
      <Suspense>
            <Routes>
                <Route path={ROUTES.Home} element={
                    <ScrollToTop>
                            <Home />
                    </ScrollToTop>
                } />
            </Routes>
            <ToastContainer />
        </Suspense>
    </Router>
  );
}

export default App;
